import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import TextField from "@material-ui/core/TextField";
import CloseIcon from "@material-ui/icons/Close";
import SendIcon from "@material-ui/icons/Send";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import CircularProgress from "@material-ui/core/CircularProgress";

class WaitListDrawerContent extends Component {
  state = {
    selectedWaitingList: 0,
  };
  handleSelect = (e) => {
    this.setState({ selectedWaitingList: e.target.value });
  };

  handleContinue = () => {
    this.props.history.push("/waitlist", {
      waiting_list: this.props.waiting_lists[this.state.selectedWaitingList],
    });
  };
  render() {
    const language = this.props.language;
    let waiting_lists = this.props.waiting_lists.map((waiting_list, index) => (
      <MenuItem value={index}>
        {language === "english" ? waiting_list.name : waiting_list.name_arabic}
      </MenuItem>
    ));
    return (
      <div>
        <span
          style={{
            position: "absolute",
            top: 15,
            right: language == "english" && 15,
            left: language == "arabic" && 15,
          }}
        >
          <CloseIcon
            onClick={() => this.props.closeDrawer()}
            style={{ color: "#565656" }}
          />
        </span>
        <h2
          className={"mx-auto ".concat(
            language == "english" ? "text-left" : "text-right"
          )}
          style={{ width: "90%", marginTop: 25, fontSize: "1.2rem" }}
        >
          {language == "english"
            ? "Select Waiting List"
            : "اختر قائمة الانتظار"}
        </h2>

        <Select
          className=" mb-3 w-75"
          value={this.state.selectedWaitingList}
          onChange={this.handleSelect}
          style={{ top: 23 }}
        >
          {waiting_lists}
        </Select>
        <Button
          className="mt-2 mb-1"
          variant="contained"
          color="primary"
          style={{
            width: "92%",
            height: 50,
            position: "absolute",
            bottom: 15,
            left: 0,
            right: 0,
            margin: "auto",
          }}
          disableElevation
          onClick={() => this.handleContinue()}
        >
          {this.state.loading ? (
            <span>
              <CircularProgress
                style={{
                  zIndex: 50,
                  color: "white",
                  width: 30,
                  height: 30,
                }}
              />
            </span>
          ) : language == "english" ? (
            "Continue"
          ) : (
            "إكمال"
          )}
        </Button>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    customerContact: state.customers.customerContact,
  };
};

export default connect(mapStateToProps)(WaitListDrawerContent);
